import React from "react";
import { services } from '../utils/constants';

export default function Services () {

    return (
        <div className="services">
            <h2>Activiteiten</h2>
            <div>
                <ul>
                    {services.map((service) => {
                        const { id, name, description, location, image } = service;
                        return (
                            <>
                                <li key={id}>
                                    <h3>{name}</h3>
                                    <p className='services-loc-info'>{description}</p>
                                    <h5>Locatie</h5>
                                    <p className='services-loc-info'>
                                        {location.name} <br />
                                        {location.address}
                                    </p>
                                    <img src={image.url} alt={image.alt} />
                                </li>
                                <br />
                            </>
                        );
                    })}
               </ul>
            </div>
        </div>
    );
};